import { Select } from 'antd';
import cn from 'classnames';

import { useLeadsRegistryDateRollover } from '../../../../hooks/useLeadsRegistryDateRollover';
import { useLeadsRegistryScopedFilters } from '../../../../hooks/useLeadsRegistryFilters';
import { LEADS_REGISTRY_PERIOD_TYPE_OPTIONS } from '../../../../model/constants';
import { LeadsPeriodPicker } from '../components/LeadsPeriodPicker';

import type {
  LeadsRegistryFilterScope,
  LeadsRegistryPeriodType,
} from '../../../../model/types';
import type { FC } from 'react';

import './LeadsRegistryDateFilter.scss';

interface LeadsRegistryDateFilterProps {
  filterScope?: LeadsRegistryFilterScope;
}

// Leads period filter. Reuses the scoped filter store (`filters.dates` and
// `filters.periodType` stay the source of truth). The period type
// (`В работе` / `Созданы`) is exposed as an external menu next to the calendar
// trigger, mirroring the search block layout. Shared by the Registry and
// Funnels filter bars.
export const LeadsRegistryDateFilter: FC<LeadsRegistryDateFilterProps> = ({
  filterScope = 'registry',
}) => {
  const { filters, onDatesChange, onDatePresetChange, onPeriodTypeChange } =
    useLeadsRegistryScopedFilters(filterScope);

  // The period filter is always mounted with the registry, so the day-rollover
  // watcher lives here: it keeps preset-driven ranges on the current day for a
  // tab that is never reloaded (both scopes are actualized at once).
  useLeadsRegistryDateRollover();

  const isActive = filters.dates.some(Boolean);

  return (
    <div
      className={cn('LeadsRegistryDateFilter', {
        'LeadsRegistryDateFilter--active': isActive,
      })}
    >
      <Select<LeadsRegistryPeriodType>
        className="LeadsRegistryDateFilter__period-type"
        classNames={{
          popup: { root: 'LeadsRegistryDateFilter__period-type-options' },
        }}
        size="small"
        variant="borderless"
        value={filters.periodType}
        options={LEADS_REGISTRY_PERIOD_TYPE_OPTIONS}
        onChange={onPeriodTypeChange}
      />
      <span className="LeadsRegistryDateFilter__divider" />
      <LeadsPeriodPicker
        dates={filters.dates}
        activePresetId={filters.datePreset}
        onDatesChange={onDatesChange}
        onDatePresetChange={onDatePresetChange}
      />
    </div>
  );
};
